module.exports = __webpack_public_path__ + "img/JORNAY_Vector_Charts-2.04eda07c.png";